import {Component, OnInit} from '@angular/core';
import {DeleteShiftDraft, SetSelectedShiftDraft} from '@app/core/store/actions/shift-drafts.actions';
import {IAppState} from '@app/core/store/state/app.state';
import {Store} from '@ngrx/store';
import {ShiftDraft} from '@app/core/models/ShiftDraft.model';
import {IQOSelectData} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-select-data';
import {MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {selectSelectedShiftDraft, selectShiftDrafts} from '@app/core/store/selectors/shift-drafts.selectors';
import {getCurrentState} from '@app/core/helpers';
import {LocalDatePipe} from '@app/support/pipes/local-date.pipe';

@Component({
	selector: 'app-select-shift-draft-popup',
	templateUrl: './select-shift-draft-popup.component.html',
	styleUrls: ['./select-shift-draft-popup.component.scss'],
})
export class SelectShiftDraftPopupComponent implements OnInit {
	public shiftDrafts$: Observable<ShiftDraft[]> = this.store.select(selectShiftDrafts);
	public selectedShiftDraft$: Observable<ShiftDraft> = this.store.select(selectSelectedShiftDraft);

	public options: IQOSelectData<ShiftDraft>[] = [];
	public selectedOption: IQOSelectData<ShiftDraft>;

	constructor(
		public dialogRef: MatDialogRef<SelectShiftDraftPopupComponent>,
		public store: Store<IAppState>,
		public localDatePipe: LocalDatePipe,
	) {
		this.shiftDrafts$.subscribe(shiftDrafts => {
			if (shiftDrafts.length === 0) {
				this.dialogRef.close();
			}
			this.options = shiftDrafts.map(shiftDraft => ({
				data: shiftDraft,
				text: shiftDraft.name,
				additionalText: this.formatDate(shiftDraft.created_at),
			}));
			if (getCurrentState(this.store).shiftDrafts.selectedShiftDraft) {
				this.selectedOption = this.options.find(o => o.data.id === getCurrentState(this.store).shiftDrafts.selectedShiftDraft.id);
			}
		});
		this.selectedShiftDraft$.subscribe(shiftDraft => {
			if (shiftDraft) {
				this.selectedOption = this.options.find(o => o.data.id === shiftDraft.id);
			}
		});
	}

	public ngOnInit(): void {
	}

	public formatDate(d: string): any {
		return this.localDatePipe.transform(d);
	}

	public close(): void {
		this.dialogRef.close();
	}

	public removeShiftDraft(): void {
		this.store.dispatch(new DeleteShiftDraft(this.selectedOption.data));
		if (
			getCurrentState(this.store).shiftDrafts.selectedShiftDraft
			&& getCurrentState(this.store).shiftDrafts.selectedShiftDraft.id === this.selectedOption.data.id
		) {
			this.store.dispatch(new SetSelectedShiftDraft(null));
		}
	}

	public selectShiftDraft(): void {
		this.store.dispatch(new SetSelectedShiftDraft(this.selectedOption.data));
		this.dialogRef.close();
	}

}
